export const CHANGE_JOBPOSITION_FILTER = "CHANGE_JOBPOSITION_FILTER";
export const RESET_JOBPOSITION_FILTER = "RESET_JOBPOSITION_FILTER";

const initialState = {
  state: "",
  location: "",
  query: "",
  offers: "",
  application_id: null,
  applied:false,
  selected_applications: [],
};

export default function jobpositionFilterReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CHANGE_JOBPOSITION_FILTER:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_JOBPOSITION_FILTER:
      return initialState;

    default:
      return state;
  }
}
